import styled from 'styled-components/macro'

import { OptionButton } from 'styled'

export const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`

export const NavButton = styled(OptionButton)`
  width: 150px;
  opacity: ${({ enabled, show }) => (show ? (enabled ? 1 : 0.5) : 0)};
  pointer-events: ${({ enabled }) => (enabled ? 'all' : 'none')};
`
